import Steps from './steps'
import Step from './step'

Steps.install = Vue => {
  Vue.component(Steps.name, Steps)
}

Step.install = Vue => {
  Vue.component(Step.name, Step)
}

export {Steps, Step}



// WEBPACK FOOTER //
// ./src/components/step/index.js